import { formatDetectedAt } from './formatDetectedAt';
import { relativeTimeSince } from './relativeTimeSince';

export function formatDateWithAge(moment: Date, now: Date): string {
  return `${formatDetectedAt(moment)} (${relativeTimeSince(moment, now)})`;
}
